import { render, staticRenderFns } from "./ProposalInfo.vue?vue&type=template&id=24145efe&scoped=true&"
import script from "./ProposalInfo.vue?vue&type=script&lang=js&"
export * from "./ProposalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24145efe",
  null
  
)

export default component.exports